import type { FormStateId } from '#types';
import { draftFormStateId } from './draftFormStateId';

/** True when `state` is the editable / in-progress line (`draftFormStateId`). */
export function isDraftFormState(state: FormStateId): boolean {
  return state === draftFormStateId;
}
